import { ColumnDef, Row } from "@tanstack/react-table"
import { useCallback, useState } from "react"
import XLSX from "xlsx-js-style"
import { ExportExcelProps, TableLoadingStateEnum } from "./tableProps.interface"

const useTableExport = (
): [number,(convertedTable: any []) => void] => {
  const [state, setState] = useState<TableLoadingStateEnum>(2)

  const exportTable = useCallback((convertedTable: any[]) => {
    setState(1)
    setTimeout(() => {
      try {
        let columns = convertedTable[0] as string[]
        const ws = XLSX.utils.aoa_to_sheet(convertedTable)
        const range = XLSX.utils.decode_range(ws["!ref"]!)
        ws["!autofilter"] = { ref: XLSX.utils.encode_range(range) }

        // widen columns
        ws["!cols"] = columns.map(() => ({ wch: 25 }))

        // HEADER STYLING
        columns.forEach((_, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex })
          if (ws[cellAddress]) {
            ws[cellAddress].s = {
              fill: { fgColor: { rgb: "1C6692" } },
              font: {
                bold: true,
                color: { rgb: "FFFFFF" }
              },
              border: {
                top: { style: "thin", color: { rgb: "CCCCCC" } },
                bottom: { style: "thin", color: { rgb: "CCCCCC" } },
                left: { style: "thin", color: { rgb: "CCCCCC" } },
                right: { style: "thin", color: { rgb: "CCCCCC" } }
              }
            }
          }
        })

        // ROW STYLING + BORDERS
        convertedTable.forEach((row, rowIndex) => {
          if (rowIndex === 0) return

          for (let colIndex = 0; colIndex < columns.length; colIndex++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })

            if (!ws[cellAddress]) ws[cellAddress] = { t: "s", v: "" }
            if (!ws[cellAddress].s) ws[cellAddress].s = {}

            // Alternating grey background
            if (rowIndex % 2 === 1) {
              ws[cellAddress].s.fill = { fgColor: { rgb: "E6E6E6" } }
            }

            // Add borders to every cell
            ws[cellAddress].s.border = {
              top: { style: "thin", color: { rgb: "CCCCCC" } },
              bottom: { style: "thin", color: { rgb: "CCCCCC" } },
              left: { style: "thin", color: { rgb: "CCCCCC" } },
              right: { style: "thin", color: { rgb: "CCCCCC" } }
            }
          }
        })

        // ALIGNMENT ADDED TO ALL CELLS
        Object.keys(ws)
          .filter(key => key[0] !== "!")
          .forEach(cellAddress => {
            if (!ws[cellAddress].s) ws[cellAddress].s = {}

            ws[cellAddress].s.alignment = {
              horizontal: "left",
              wrapText: false,
              shrinkToFit: true
            }

            // Ensure borders on any cell that didn't get them yet
            if (!ws[cellAddress].s.border) {
              ws[cellAddress].s.border = {
                top: { style: "thin", color: { rgb: "CCCCCC" } },
                bottom: { style: "thin", color: { rgb: "CCCCCC" } },
                left: { style: "thin", color: { rgb: "CCCCCC" } },
                right: { style: "thin", color: { rgb: "CCCCCC" } }
              }
            }
          })

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
        XLSX.writeFile(wb, "transportportal_export.xlsx")

        setState(2)
      } catch {
        setState(3)
      }
    }, 200)
  }, [])

  return [state, exportTable]
}

export default useTableExport
